export const SITES_STORE_API_KEY = 'sitesApi';
export const SITES_GET_LIST_API = '/sites';
export const SITES_GET_LOCATION =
  'https://atlas.microsoft.com/search/address/json';

export const SITE_LOCATION_CONF_RANGE = 0.7;
